import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { portfolios } from '../../mocks/portfolios';
import PortfolioModal from '../../components/feature/PortfolioModal';

export default function PortfolioPage() {
  const [filter, setFilter] = useState('전체');
  const [selectedPortfolio, setSelectedPortfolio] = useState<typeof portfolios[0] | null>(null);

  useEffect(() => {
    // SEO Meta Tags
    document.title = '포트폴리오 - 유흥디자인랩 | 구인광고 홈페이지 제작 사례';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '유흥디자인랩의 다양한 포트폴리오를 확인하세요. 강남, 홍대, 청담 등 서울 주요 지역의 구인광고 및 홈페이지 제작 사례. 전문적이고 효과적인 디자인 결과물을 만나보세요.');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "유흥디자인랩 포트폴리오",
      "description": "유흥업계 전문 디자인 포트폴리오",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/portfolio`,
      "mainEntity": {
        "@type": "ItemList",
        "itemListElement": portfolios.slice(0, 10).map((portfolio, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "item": {
            "@type": "CreativeWork",
            "name": portfolio.title,
            "description": portfolio.description,
            "category": portfolio.category
          }
        }))
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const categories = ['전체', '웹사이트', '이커머스', '브랜딩', '모바일 앱'];

  const filteredPortfolios =
    filter === '전체'
      ? portfolios
      : portfolios.filter((p) => p.category === filter);

  return (
    <>
      <div className="min-h-screen bg-white">
        <Navbar />

        <section className="pt-32 pb-16 bg-gradient-to-br from-neon-pink/5 to-purple-500/5">
          <div className="max-w-7xl mx-auto px-6">
            <h1 className="text-5xl font-bold mb-6 text-center">포트폴리오</h1>
            <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto">
              다양한 산업 분야에서 성공적으로 완료한 프로젝트들을 만나보세요
            </p>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex flex-wrap justify-center gap-3 mb-12">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setFilter(category)}
                  className={`px-6 py-2 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
                    filter === category
                      ? 'bg-neon-pink text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPortfolios.map((portfolio) => (
                <div
                  key={portfolio.id}
                  onClick={() => setSelectedPortfolio(portfolio)}
                  className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <span className="inline-block px-3 py-1 bg-neon-pink/10 text-neon-pink text-xs font-semibold rounded-full mb-4">
                    {portfolio.category}
                  </span>
                  <h3 className="text-xl font-bold mb-3">{portfolio.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {portfolio.description}
                  </p>
                </div>
              ))}
            </div>

            {filteredPortfolios.length === 0 && (
              <div className="text-center py-20">
                <p className="text-gray-600 text-lg">
                  해당 카테고리의 포트폴리오가 없습니다.
                </p>
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>

      <PortfolioModal
        portfolio={selectedPortfolio}
        onClose={() => setSelectedPortfolio(null)}
      />
    </>
  );
}
